module.exports = __webpack_public_path__ + "media/images/social-icon-3-1498e31326d14bf95650e72fb1b3006a.png";